(() => {
  const ELEMENT_NAME = 'luma-product-selector';
  const STORAGE_VERSION = 3;
  const DEFAULT_PACK_READY_EVENT = 'luma:pack-ready';
  const registry = window.LumaCollection || {
    instances: new Map(),
    getState(sectionId) {
      const instance = this.instances.get(sectionId);
      return instance ? instance.getPublicState() : null;
    },
  };
  window.LumaCollection = registry;

  class LumaProductSelector extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.sectionId = this.dataset.sectionId || 'luma';
      this.storageKey = `luma:selector:${this.dataset.collectionHandle || 'collection'}:v${STORAGE_VERSION}`;

      this.openLumaSelectionDrawer = () => {
        const opener = document.querySelector('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]');
        if (opener) opener.click();
        const drawer = document.querySelector('#cart-drawer');
        if (drawer) {
          drawer.setAttribute('open', '');
          drawer.removeAttribute('hidden');
          drawer.setAttribute('aria-hidden', 'false');
          drawer.classList.add('is-open', 'active', 'open');
          drawer.style.setProperty('display', 'block', 'important');
          drawer.style.setProperty('visibility', 'visible', 'important');
          drawer.style.setProperty('opacity', '1', 'important');
          drawer.style.setProperty('transform', 'translateX(0)', 'important');
        }
        requestAnimationFrame(() => this.renderLumaSelectionCart());
      };
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest && event.target.closest('[data-luma-selection-trigger]');
        if (!trigger) return;
        event.preventDefault();
        event.stopPropagation();
        this.openLumaSelectionDrawer();
      });

      this.ensureSelectionCartTrigger = () => {
        let trigger = document.querySelector('[data-luma-selection-trigger]');
        if (!trigger) {
          trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.dataset.lumaSelectionTrigger = '';
          trigger.setAttribute('aria-label', 'فتح العطور المختارة');
          trigger.style.cssText = 'position:fixed;right:14px;bottom:86px;z-index:2147483000;width:50px;height:50px;border:0;border-radius:16px;background:#171717;color:#fff;display:grid;place-items:center;box-shadow:0 12px 28px rgba(0,0,0,.22);cursor:pointer;';
          trigger.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" style="width:25px;height:25px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round"><path d="M6 8h12l1 13H5L6 8Zm3 0V6a3 3 0 0 1 6 0v2"/></svg><b data-luma-selection-trigger-count style="position:absolute;top:-6px;right:-6px;min-width:22px;height:22px;padding:0 5px;border-radius:999px;background:#b8975b;color:#fff;display:grid;place-items:center;font:700 11px/1 Arial,sans-serif">0</b>';
          trigger.addEventListener('click', () => {
            const opener = document.querySelector('[data-testid="cart-drawer-trigger"][aria-controls="cart-drawer"], [aria-controls="cart-drawer"]');
            if (opener) opener.click();
            else {
              const drawer = document.querySelector('#cart-drawer');
              if (drawer) {
                drawer.setAttribute('open', '');
                drawer.removeAttribute('hidden');
              }
            }
            requestAnimationFrame(() => this.renderLumaSelectionCart());
          });
          if (document.body) document.body.appendChild(trigger);
        }
        const triggerHost = this.summary || document.body;
        if (triggerHost && trigger.parentElement !== triggerHost) triggerHost.appendChild(trigger);
        if (this.summary) {
          this.summary.style.position = 'relative';
          trigger.style.cssText = 'position:absolute;right:8px;top:50%;transform:translateY(-50%);z-index:5;width:48px;height:48px;border:0;border-radius:14px;background:#171717;color:#fff;display:grid;place-items:center;box-shadow:0 8px 18px rgba(0,0,0,.2);cursor:pointer;';
        } else {
          trigger.style.cssText = 'position:fixed;right:14px;bottom:86px;z-index:2147483000;width:50px;height:50px;border:0;border-radius:16px;background:#171717;color:#fff;display:grid;place-items:center;box-shadow:0 12px 28px rgba(0,0,0,.22);cursor:pointer;';
        }
        let stored = null;
        try { stored = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null'); } catch (error) { stored = null; }
        const count = Array.isArray(stored && stored.selectedProducts) ? stored.selectedProducts.length : 0;
        const badge = trigger.querySelector('[data-luma-selection-trigger-count]');
        if (badge) badge.textContent = String(count);
        trigger.hidden = false;
        trigger.style.setProperty('display', 'grid', 'important');
      };
      this.renderLumaSelectionCart = () => {
        this.ensureSelectionCartTrigger();
        const drawer = document.querySelector('#cart-drawer');
        const content = drawer?.querySelector('.cart-drawer__content');
        if (!drawer || !content) return;
        let stored = null;
        try {
          stored = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
        } catch (error) {
          stored = null;
        }
        const products = stored && Array.isArray(stored.selectedProducts) ? stored.selectedProducts : [];
        const escapeHtml = (value) =>
          String(value ?? '').replace(/[&<>"']/g, (character) =>
            ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]),
          );
        const emptyHeading = drawer.querySelector('#cart-drawer-heading');
        const emptyWrapper = drawer.querySelector('.cart-items__wrapper--drawer-empty');
        let panel = content.querySelector('[data-luma-selection-cart]');
        if (!products.length) {
          panel?.remove();
          if (emptyHeading) emptyHeading.hidden = false;
          if (emptyWrapper) emptyWrapper.hidden = false;
          return;
        }
        if (emptyHeading) { emptyHeading.hidden = true; emptyHeading.style.display = 'none'; }
        if (emptyWrapper) { emptyWrapper.hidden = true; emptyWrapper.style.display = 'none'; }
        if (!document.getElementById('luma-selection-cart-style')) { const style = document.createElement('style'); style.id = 'luma-selection-cart-style'; style.textContent = `
#cart-drawer .cart-drawer__inner{box-sizing:border-box}
#cart-drawer .cart-drawer__content{box-sizing:border-box;display:flex;align-items:stretch;justify-content:flex-start;gap:0;min-height:0;padding:1rem;overflow-y:auto}
#cart-drawer .luma-selection-cart{box-sizing:border-box;width:100%;margin:0 0 1rem;padding:1.1rem;border:1px solid rgba(17,17,17,.1);border-radius:24px;background:linear-gradient(145deg,#fffdf9 0%,#f6f0e6 100%);box-shadow:0 14px 30px rgba(17,17,17,.08);direction:rtl;color:#171717}
#cart-drawer .luma-selection-cart__header{display:flex;align-items:flex-start;justify-content:space-between;gap:.8rem;margin-bottom:1rem}
#cart-drawer .luma-selection-cart__heading{display:grid;gap:.2rem;min-width:0}
#cart-drawer .luma-selection-cart__eyebrow{font-size:.68rem;font-weight:700;letter-spacing:.08em;color:#a3814d;text-transform:uppercase}
#cart-drawer .luma-selection-cart__heading strong{font-size:1.15rem;line-height:1.25;font-weight:800}
#cart-drawer .luma-selection-cart__count{display:inline-flex;align-items:center;justify-content:center;min-width:2.65rem;height:2.1rem;padding:0 .55rem;border-radius:999px;background:#171717;color:#fff;font-size:.78rem;font-weight:800;white-space:nowrap}
#cart-drawer .luma-selection-cart__items{display:grid;gap:.55rem}
#cart-drawer .luma-selection-cart__item{display:grid;grid-template-columns:3.6rem minmax(0,1fr) 2rem;align-items:center;gap:.65rem;padding:.55rem;border:1px solid rgba(17,17,17,.08);border-radius:16px;background:rgba(255,255,255,.86)}
#cart-drawer .luma-selection-cart__media{display:flex;align-items:center;justify-content:center;width:3.6rem;height:3.6rem;border:1px solid rgba(17,17,17,.08);border-radius:12px;background:#fff;overflow:hidden}
#cart-drawer .luma-selection-cart__media img{display:block;width:100%;height:100%;padding:.25rem;object-fit:contain}
#cart-drawer .luma-selection-cart__media>span{font-size:1.2rem;color:#b08a4d}
#cart-drawer .luma-selection-cart__details{display:grid;min-width:0;gap:.25rem}
#cart-drawer .luma-selection-cart__details strong{display:-webkit-box;overflow:hidden;font-size:.86rem;line-height:1.35;font-weight:750;-webkit-box-orient:vertical;-webkit-line-clamp:2}
#cart-drawer .luma-selection-cart__details span{font-size:.72rem;color:#777}
#cart-drawer .luma-selection-cart__remove{display:inline-flex;align-items:center;justify-content:center;width:2rem;height:2rem;padding:0;border:1px solid rgba(180,35,24,.2);border-radius:999px;background:#fff;color:#b42318;font-size:1.2rem;line-height:1;cursor:pointer;transition:background .2s ease,color .2s ease,transform .2s ease}
#cart-drawer .luma-selection-cart__remove:hover{background:#b42318;color:#fff;transform:scale(1.04)}
#cart-drawer .luma-selection-cart__footer{display:grid;gap:.75rem;margin-top:1rem;padding-top:.9rem;border-top:1px solid rgba(17,17,17,.1)}
#cart-drawer .luma-selection-cart__total{display:flex;align-items:center;justify-content:space-between;gap:1rem;font-size:.86rem;color:#6c6c6c}
#cart-drawer .luma-selection-cart__total strong{font-size:1.08rem;color:#171717}
#cart-drawer .luma-selection-cart__order{display:flex;align-items:center;justify-content:center;width:100%;min-height:50px;padding:.8rem 1rem;border:0;border-radius:14px;background:#171717;color:#fff;font:inherit;font-size:.92rem;font-weight:800;cursor:pointer;transition:background .2s ease,transform .2s ease}
#cart-drawer .luma-selection-cart__order::after{content:'←';margin-inline-start:.45rem;font-size:1rem}
#cart-drawer .luma-selection-cart__order:hover{background:#a3814d;transform:translateY(-1px)}
@media (max-width:749px){
  #cart-drawer .cart-drawer__inner{height:100dvh;max-height:100dvh}
  #cart-drawer .cart-drawer__content{padding:.75rem;justify-content:flex-start;overflow-y:auto}
  #cart-drawer .luma-selection-cart{margin:0;padding:.85rem;border-radius:22px}
  #cart-drawer .luma-selection-cart__header{margin-bottom:.8rem}
  #cart-drawer .luma-selection-cart__heading strong{font-size:1.04rem}
  #cart-drawer .luma-selection-cart__items{max-height:46dvh;overflow-y:auto;padding:.05rem}
  #cart-drawer .luma-selection-cart__item{grid-template-columns:3.2rem minmax(0,1fr) 1.9rem;gap:.55rem;padding:.45rem;border-radius:14px}
  #cart-drawer .luma-selection-cart__media{width:3.2rem;height:3.2rem;border-radius:10px}
  #cart-drawer .luma-selection-cart__details strong{font-size:.8rem}
  #cart-drawer .luma-selection-cart__details span{font-size:.7rem}
  #cart-drawer .luma-selection-cart__footer{margin-top:.8rem;padding-top:.75rem;gap:.65rem}
  #cart-drawer .luma-selection-cart__order{min-height:48px;border-radius:13px}
}
`; document.head.append(style); } if (!panel) {
          panel = document.createElement('div');
          panel.dataset.lumaSelectionCart = '';
          panel.className = 'luma-selection-cart';
          content.prepend(panel);
        }
        panel.innerHTML = `<div class="luma-selection-cart__header"><div class="luma-selection-cart__heading"><span class="luma-selection-cart__eyebrow">اختيارات LUMA</span><strong>العطور المختارة</strong></div><span class="luma-selection-cart__count">${products.length}/${stored.offerQuantity || products.length}</span></div><div class="luma-selection-cart__items">${products.map((product) => { const productId = escapeHtml(product.productId); const title = escapeHtml(product.title || 'عطر مختار'); const imageUrl = escapeHtml(product.imageUrl || ''); const imageMarkup = imageUrl ? '<img src="' + imageUrl + '" alt="' + title + '" loading="lazy" decoding="async">' : '<span aria-hidden="true">✦</span>'; return '<div class="luma-selection-cart__item" data-luma-selection-item="' + productId + '"><div class="luma-selection-cart__media">' + imageMarkup + '</div><div class="luma-selection-cart__details"><strong>' + title + '</strong><span>الكمية: 1</span></div><button type="button" class="luma-selection-cart__remove" data-luma-selection-remove="' + productId + '" aria-label="حيد ' + title + '">×</button></div>'; }).join('')}</div><div class="luma-selection-cart__footer"><div class="luma-selection-cart__total"><span>المجموع</span><strong>${stored.totalPrice ? (stored.totalPrice / 100) + ' DH' : (stored.offerQuantity === 3 ? '450 DH' : stored.offerQuantity === 2 ? '300 DH' : '200 DH')}</strong></div><button type="button" class="luma-selection-cart__order" data-luma-selection-order>اطلب الآن</button></div>`;
      };
      document.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-luma-selection-remove]');
        if (removeButton) { event.preventDefault(); event.stopPropagation();
          const card = document.querySelector(`[data-product-id="${CSS.escape(removeButton.dataset.lumaSelectionRemove)}"]`);
          card?.querySelector('[data-luma-select]')?.click();
          return;
        }
        if (event.target.closest('[data-luma-selection-order]')) {
          document.querySelectorAll('button').forEach((button) => {
            if (button.textContent.trim() === 'اطلب الآن' && !button.closest('[data-luma-selection-cart]')) button.click();
          });
        }
      });
      const selectionObserver = new MutationObserver((records) => {
        if (records.some((record) => !record.target.closest?.('[data-luma-selection-cart]'))) this.renderLumaSelectionCart();
      });
      selectionObserver.observe(document.body, { childList: true, subtree: true });
      this.renderLumaSelectionCart();
    requestAnimationFrame(() => {
      const excludedHandle = new URLSearchParams(window.location.search).get('luma_exclude');
      if (!excludedHandle) return;
      const hideExcluded = () => {
        document.querySelectorAll("a[href*='/products/']").forEach((link) => {
          const handle = new URL(link.href, window.location.origin).pathname.split('/').filter(Boolean).pop();
          if (handle !== excludedHandle) return;
          const card = link.closest('li, [data-product-handle], .product-card, .card') || link;
          card.hidden = true;
        });
      };
      hideExcluded();
      const observer = new MutationObserver(hideExcluded);
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 5000);
      if (!excludedHandle) return;
      document.querySelectorAll('[data-product-handle]').forEach((element) => {
        if (element.dataset.productHandle !== excludedHandle) return;
        const card = element.closest('li') || element;
        card.hidden = true;
      });
    });
      const configuredProductIds = (this.dataset.offerProductIds || '')
        .split(',')
        .map((productId) => productId.trim())
        .filter(Boolean);
      this.allowedProductIds = new Set(configuredProductIds);
      this.hasCompleteOfferCatalog =
        this.allowedProductIds.size >= Number(this.dataset.totalProducts || 0);
      this.isCatalogLoading = false;
      this.isPageLoading = false;
      this.catalogRequestSequence = 0;
      this.catalogController = null;
      this.pageController = null;
      this.pendingCatalogUrl = null;
      this.pendingCatalogPushHistory = false;
      this.failedAction = 'page';
      this.selected = [];
      this.offerQuantity = this.safeQuantity(this.dataset.defaultOffer) || 2;
      this.offerPrice = this.priceForQuantity(this.offerQuantity);
      this.noticeTimer = null;
      this.pendingFlights = new Set();
      this.activeFlights = new Map();

      this.refreshElements();
      this.resetCatalogTracking();
      this.restoreState();

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.onPopState = this.onPopState.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('toggle', this.onToggle, true);
      window.addEventListener('popstate', this.onPopState);

      this.render();
      this.syncFilterExpandedStates();
      this.setupObserver();
      this.setupFooterObserver();
      registry.instances.set(this.sectionId, this);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('toggle', this.onToggle, true);
      window.removeEventListener('popstate', this.onPopState);
      this.observer?.disconnect();
      this.footerObserver?.disconnect();
      this.catalogController?.abort();
      this.pageController?.abort();
      if (registry.instances.get(this.sectionId) === this) {
        registry.instances.delete(this.sectionId);
      }
      if (this.noticeTimer) window.clearTimeout(this.noticeTimer);
      this.activeFlights.forEach((flight) => flight.cancel());
      this.activeFlights.clear();
      this.pendingFlights.clear();
    }

    refreshElements() {
      this.controls = this.querySelector('[data-luma-controls]');
      this.grid = this.querySelector('[data-luma-grid]');
      this.empty = this.querySelector('[data-luma-empty]');
      this.sentinel = this.querySelector('[data-luma-sentinel]');
      this.loader = this.querySelector('[data-luma-loader]');
      this.loadError = this.querySelector('[data-luma-load-error]');
      this.loadEnd = this.querySelector('[data-luma-load-end]');
      this.progressMessage = this.querySelector('[data-luma-progress-message]');
      this.progressCount = this.querySelector('[data-luma-progress-count]');
      this.progressSteps = this.querySelector('[data-luma-progress-steps]');
      this.notice = this.querySelector('[data-luma-notice]');
      this.summaryCount = this.querySelector('[data-luma-summary-count]');
      this.summaryMessage = this.querySelector('[data-luma-summary-message]');
      this.summary = this.querySelector('[data-luma-summary]');
      this.thumbnails = this.querySelector('[data-luma-thumbnails]');
      this.total = this.querySelector('[data-luma-total]');
      this.cta = this.querySelector('[data-luma-cta]');
    }

    resetCatalogTracking() {
      const initialPage = Number(this.grid?.dataset.page || 1);
      this.nextUrl = this.sentinel?.dataset.nextUrl || '';
      this.loadedPages = new Set([
        Number.isFinite(initialPage) && initialPage > 0 ? initialPage : 1,
      ]);
      this.seenProductIds = new Set();
      this.querySelectorAll('[data-luma-card]').forEach((card) => {
        if (card.dataset.productId) {
          this.seenProductIds.add(card.dataset.productId);
        }
      });
    }

    label(name) {
      return this.dataset[name] || '';
    }

    safeQuantity(value) {
      const quantity = Number(value);
      return [1, 2, 3].includes(quantity) ? quantity : null;
    }

    priceForQuantity(quantity) {
      const offer = this.querySelector(
        `[data-luma-offer][data-quantity="${quantity}"]`,
      );
      const price = Number(offer?.dataset.price);
      return Number.isFinite(price) && price > 0 ? price : 0;
    }

    validProduct(value) {
      if (!value || typeof value !== 'object') return null;
      const required = [
        'productId',
        'variantId',
        'title',
        'handle',
        'imageUrl',
        'productUrl',
      ];
      if (required.some((key) => typeof value[key] !== 'string')) return null;
      if (!value.productId || !value.variantId || !value.title || !value.handle) {
        return null;
      }
      return {
        productId: value.productId,
        variantId: value.variantId,
        title: value.title.slice(0, 240),
        handle: value.handle.slice(0, 180),
        imageUrl: value.imageUrl,
        productUrl: value.productUrl,
      };
    }

    restoreState() {
      let stored;
      try {
        stored = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
      } catch {
        try {
          sessionStorage.removeItem(this.storageKey);
        } catch {
          // Selection remains functional when sessionStorage is unavailable.
        }
        return;
      }
      if (!stored || stored.version !== STORAGE_VERSION) return;

      const quantity = this.safeQuantity(stored.offerQuantity);
      if (quantity) {
        this.offerQuantity = quantity;
        this.offerPrice = this.priceForQuantity(quantity);
      }

      const unique = new Set();
      const restored = Array.isArray(stored.selectedProducts)
        ? stored.selectedProducts
            .map((item) => this.validProduct(item))
            .filter(
              (item) =>
                item && !unique.has(item.productId) && unique.add(item.productId),
            )
        : [];
      this.selected = restored.slice(0, this.offerQuantity);
      this.sanitizeSelected();
    }

    sanitizeSelected() {
      if (!this.hasCompleteOfferCatalog) return;
      this.selected = this.selected.filter((product) =>
        this.allowedProductIds.has(product.productId),
      );
    }

    persist() {
      const state = {
        version: STORAGE_VERSION,
        offerQuantity: this.offerQuantity,
        selectedProducts: this.selected,
      };
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch {
        // Selection remains fully functional when sessionStorage is unavailable.
      }
      return state;
    }

    productFromCard(card) {
      return this.validProduct({
        productId: card.dataset.productId || '',
        variantId: card.dataset.variantId || '',
        title: card.dataset.productTitle || '',
        handle: card.dataset.productHandle || '',
        imageUrl: card.dataset.imageUrl || '',
        productUrl: card.dataset.productUrl || '',
      });
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const productLink = target.closest('a[href*="/products/"]');
      if (productLink && this.contains(productLink)) {
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const destination = new URL(productLink.href, window.location.origin);
        if (destination.origin !== window.location.origin) return;
        event.preventDefault();
        this.persist();
        destination.searchParams.set('luma_offer', '1');
        window.location.assign(destination.toString());
        return;
      }

      const offer = target.closest('[data-luma-offer]');
      if (offer && this.contains(offer)) {
        this.changeOffer(this.safeQuantity(offer.dataset.quantity));
        return;
      }

      const selectButton = target.closest('[data-luma-select]');
      if (selectButton && this.contains(selectButton)) {
        const card = selectButton.closest('[data-luma-card]');
        if (card) this.toggleProduct(card);
        return;
      }

      const clearFilter = target.closest('[data-luma-clear-filter]');
      if (clearFilter && this.contains(clearFilter)) {
        const filterParam = clearFilter.dataset.filterParam || '';
        this.querySelectorAll('[data-luma-filter-input]').forEach((input) => {
          if (
            input instanceof HTMLInputElement &&
            (!filterParam || input.name === filterParam)
          ) {
            input.checked = false;
          }
        });
        this.applyCatalogControls();
        return;
      }

      if (target.closest('[data-luma-retry]')) {
        if (this.failedAction === 'catalog' && this.pendingCatalogUrl) {
          this.reloadCatalog(
            this.pendingCatalogUrl,
            this.pendingCatalogPushHistory,
          );
        } else {
          this.loadNextPage();
        }
        return;
      }

      if (target.closest('[data-luma-cta]') && !this.cta?.disabled) {
        this.emitPackReady();
      }
    }

    onChange(event) {
      const target = event.target;
      if (
        target instanceof Element &&
        (target.matches('[data-luma-sort]') ||
          target.matches('[data-luma-filter-input]'))
      ) {
        this.applyCatalogControls();
      }
    }

    onSubmit(event) {
      if (!(event.target instanceof HTMLFormElement)) return;
      if (!event.target.matches('[data-luma-filter-form]')) return;
      event.preventDefault();
      this.applyCatalogControls();
    }

    onToggle(event) {
      if (
        event.target instanceof HTMLDetailsElement &&
        event.target.matches('[data-luma-filter-disclosure]')
      ) {
        this.syncFilterExpandedState(event.target);
      }
    }

    onPopState() {
      this.reloadCatalog(new URL(window.location.href), false);
    }

    syncFilterExpandedState(disclosure) {
      const summary = disclosure.querySelector('summary');
      summary?.setAttribute('aria-expanded', String(disclosure.open));
    }

    syncFilterExpandedStates() {
      this.querySelectorAll('[data-luma-filter-disclosure]').forEach((item) => {
        if (item instanceof HTMLDetailsElement) {
          this.syncFilterExpandedState(item);
        }
      });
    }

    buildCatalogUrl() {
      const url = new URL(window.location.href);
      [...url.searchParams.keys()].forEach((name) => {
        if (
          name === 'page' ||
          name === 'sort_by' ||
          name.startsWith('filter.')
        ) {
          url.searchParams.delete(name);
        }
      });

      const form = this.querySelector('[data-luma-filter-form]');
      if (!(form instanceof HTMLFormElement)) return url;

      const formData = new FormData(form);
      formData.forEach((value, name) => {
        if (typeof value === 'string' && value) {
          url.searchParams.append(name, value);
        }
      });
      return url;
    }

    applyCatalogControls() {
      this.reloadCatalog(this.buildCatalogUrl(), true);
    }

    findIncomingRoot(parsedDocument) {
      return (
        [...parsedDocument.querySelectorAll(ELEMENT_NAME)].find(
          (root) => root.dataset.sectionId === this.sectionId,
        ) || parsedDocument.querySelector(ELEMENT_NAME)
      );
    }

    abortPageRequest() {
      this.pageController?.abort();
      this.pageController = null;
      this.isPageLoading = false;
    }

    async reloadCatalog(url, pushHistory) {
      const storefrontUrl = new URL(url.toString(), window.location.origin);
      storefrontUrl.searchParams.delete('page');
      storefrontUrl.searchParams.delete('section_id');
      const requestUrl = new URL(storefrontUrl);
      requestUrl.searchParams.set('section_id', this.sectionId);

      this.catalogController?.abort();
      this.abortPageRequest();
      this.observer?.disconnect();

      const controller = new AbortController();
      const sequence = this.catalogRequestSequence + 1;
      this.catalogRequestSequence = sequence;
      this.catalogController = controller;
      this.isCatalogLoading = true;
      this.pendingCatalogUrl = storefrontUrl;
      this.pendingCatalogPushHistory = pushHistory;
      this.failedAction = 'catalog';
      this.setLoadState('loading');

      try {
        const response = await fetch(requestUrl.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const parsedDocument = new DOMParser().parseFromString(
          await response.text(),
          'text/html',
        );
        if (controller.signal.aborted || sequence !== this.catalogRequestSequence) {
          return;
        }

        const incomingRoot = this.findIncomingRoot(parsedDocument);
        const incomingControls = incomingRoot?.querySelector(
          '[data-luma-controls]',
        );
        const incomingGrid = incomingRoot?.querySelector(
          '[data-luma-page-items]',
        );
        const incomingEmpty = incomingRoot?.querySelector('[data-luma-empty]');
        const incomingSentinel = incomingRoot?.querySelector(
          '[data-luma-sentinel]',
        );
        if (
          !incomingControls ||
          !incomingGrid ||
          !incomingEmpty ||
          !incomingSentinel ||
          !this.controls ||
          !this.grid ||
          !this.empty ||
          !this.sentinel
        ) {
          throw new Error('Missing canonical catalog markup');
        }

        this.controls.replaceWith(incomingControls);
        this.grid.replaceWith(incomingGrid);
        this.empty.replaceWith(incomingEmpty);
        this.sentinel.replaceWith(incomingSentinel);
        this.refreshElements();
        this.resetCatalogTracking();

        if (pushHistory) {
          this.persist();
          history.pushState(
            { ...(history.state || {}), lumaCatalog: true },
            '',
            storefrontUrl.toString(),
          );
        }

        this.render();
        this.syncFilterExpandedStates();
        this.pendingCatalogUrl = null;
        if (this.nextUrl) {
          this.setLoadState('idle');
          this.setupObserver();
        } else {
          this.showEndState();
        }
      } catch {
        if (
          controller.signal.aborted ||
          sequence !== this.catalogRequestSequence
        ) {
          return;
        }
        this.showLoadError('catalog');
      } finally {
        if (this.catalogController === controller) {
          this.catalogController = null;
          this.isCatalogLoading = false;
        }
      }
    }

    changeOffer(quantity) {
      if (!quantity || quantity === this.offerQuantity) return;
      const removedCount = Math.max(0, this.selected.length - quantity);
      this.offerQuantity = quantity;
      this.offerPrice = this.priceForQuantity(quantity);
      if (removedCount > 0) {
        const removedProducts = this.selected.slice(quantity);
        removedProducts.forEach((product) => this.cancelFlight(product.productId));
        this.selected = this.selected.slice(0, quantity);
        this.showNotice(this.label('labelOfferTrimmed'));
      }
      this.persist();
      this.render();
    }

    toggleProduct(card) {
      const product = this.productFromCard(card);
      if (!product) return;
      const index = this.selected.findIndex(
        (item) => item.productId === product.productId,
      );

      if (index >= 0) {
        this.cancelFlight(product.productId);
        this.selected.splice(index, 1);
      } else if (this.selected.length >= this.offerQuantity) {
        this.showNotice(this.label('labelSelectionFull'));
        return;
      } else {
        this.pendingFlights.add(product.productId);
        this.selected.push(product);
      }

      this.persist();
      this.render();
      if (index < 0) {
        this.animateProductToSummary(card, product);
      }
    }

    thumbnailForProduct(productId) {
      if (!this.thumbnails) return null;
      return Array.from(this.thumbnails.children).find(
        (thumbnail) => thumbnail.dataset.productId === productId,
      ) || null;
    }

    revealThumbnail(productId, shouldPulse = true) {
      this.pendingFlights.delete(productId);
      const thumbnail = this.thumbnailForProduct(productId);
      if (!thumbnail) return;
      thumbnail.classList.remove('is-awaiting-flight');
      if (!shouldPulse) return;
      thumbnail.classList.remove('is-flight-arrival');
      setTimeout(() => {
        thumbnail.classList.add('is-flight-arrival');
        window.setTimeout(() => {
          thumbnail.classList.remove('is-flight-arrival');
        }, 260);
      });
    }

    cancelFlight(productId) {
      this.pendingFlights.delete(productId);
      const flight = this.activeFlights.get(productId);
      if (flight) {
        flight.cancel();
        this.activeFlights.delete(productId);
      }
      this.revealThumbnail(productId, false);
    }

    animateProductToSummary(card, product) {
      const destination = this.thumbnailForProduct(product.productId);
      const source = card.querySelector('.luma-card__image');
      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      ).matches;

      if (
        reducedMotion ||
        !(source instanceof HTMLImageElement) ||
        !(destination instanceof HTMLElement) ||
        typeof source.animate !== 'function'
      ) {
        this.revealThumbnail(product.productId, false);
        return;
      }

      const sourceRect = source.getBoundingClientRect();
      const destinationRect = destination.getBoundingClientRect();
      if (
        sourceRect.width <= 0 ||
        sourceRect.height <= 0 ||
        destinationRect.width <= 0 ||
        destinationRect.height <= 0
      ) {
        this.revealThumbnail(product.productId, false);
        return;
      }

      this.cancelFlight(product.productId);
      this.pendingFlights.add(product.productId);
      destination.classList.add('is-awaiting-flight');
      card.classList.add('is-flight-source');
      window.setTimeout(() => card.classList.remove('is-flight-source'), 90);

      const clone = source.cloneNode(false);
      clone.removeAttribute('id');
      clone.removeAttribute('srcset');
      clone.removeAttribute('sizes');
      clone.removeAttribute('loading');
      clone.alt = '';
      clone.setAttribute('aria-hidden', 'true');
      clone.className = 'luma-selection-flight';
      clone.style.setProperty('--luma-flight-top', `${sourceRect.top}px`);
      clone.style.setProperty('--luma-flight-left', `${sourceRect.left}px`);
      clone.style.setProperty('--luma-flight-width', `${sourceRect.width}px`);
      clone.style.setProperty('--luma-flight-height', `${sourceRect.height}px`);
      document.body.append(clone);

      const deltaX =
        destinationRect.left +
        destinationRect.width / 2 -
        (sourceRect.left + sourceRect.width / 2);
      const deltaY =
        destinationRect.top +
        destinationRect.height / 2 -
        (sourceRect.top + sourceRect.height / 2);
      const endScale = Math.min(
        destinationRect.width / sourceRect.width,
        destinationRect.height / sourceRect.height,
        0.34,
      );
      const rotation = deltaX >= 0 ? 5 : -5;
      const animation = clone.animate(
        [
          {
            opacity: 1,
            transform: 'translate3d(0, 0, 0) scale(1) rotate(0deg)',
          },
          {
            opacity: 0.96,
            transform: `translate3d(${deltaX * 0.36}px, ${
              deltaY * 0.24 - 36
            }px, 0) scale(0.82) rotate(${rotation * 0.4}deg)`,
            offset: 0.36,
          },
          {
            opacity: 0.84,
            transform: `translate3d(${deltaX * 0.76}px, ${
              deltaY * 0.69 - 18
            }px, 0) scale(0.52) rotate(${rotation * 0.8}deg)`,
            offset: 0.74,
          },
          {
            opacity: 0.64,
            transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${endScale}) rotate(${rotation}deg)`,
          },
        ],
        {
          duration: 440,
          easing: 'cubic-bezier(0.22, 0.74, 0.22, 1)',
          fill: 'forwards',
        },
      );

      const cleanup = () => {
        animation.cancel();
        clone.remove();
      };
      this.activeFlights.set(product.productId, { cancel: cleanup });
      animation.finished
        .then(() => {
          if (this.activeFlights.get(product.productId)?.cancel !== cleanup) {
            return;
          }
          this.activeFlights.delete(product.productId);
          cleanup();
          this.revealThumbnail(product.productId);
        })
        .catch(() => {
          if (this.activeFlights.get(product.productId)?.cancel === cleanup) {
            this.activeFlights.delete(product.productId);
            cleanup();
            this.revealThumbnail(product.productId, false);
          }
        });
    }

    progressText() {
      const count = this.selected.length;
      if (count >= this.offerQuantity) return this.label('labelProgressReady');
      if (count === 0 && this.offerQuantity === 1) {
        return this.label('labelProgressOne');
      }
      if (count === 0) return this.label('labelProgressFirst');
      const remaining = this.offerQuantity - count;
      return remaining === 1
        ? this.label('labelProgressOneLeft')
        : this.label('labelProgressTwoLeft');
    }

    incompleteText() {
      const remaining = this.offerQuantity - this.selected.length;
      if (remaining <= 0) return this.label('labelSummaryReady');
      if (remaining === 1) return this.label('labelSummaryOneLeft');
      if (remaining === 2) return this.label('labelSummaryTwoLeft');
      return this.label('labelSummaryManyLeft');
    }

    showNotice(message) {
      if (!this.notice || !message) return;
      this.notice.textContent = message;
      this.notice.hidden = false;
      if (this.noticeTimer) window.clearTimeout(this.noticeTimer);
      this.noticeTimer = window.setTimeout(() => {
        this.notice.hidden = true;
        this.notice.textContent = '';
      }, 3600);
    }

    render() {
      const selectedIds = new Map(
        this.selected.map((product, index) => [product.productId, index + 1]),
      );

      this.querySelectorAll('[data-luma-offer]').forEach((offer) => {
        const selected =
          Number(offer.dataset.quantity) === this.offerQuantity;
        offer.classList.toggle('is-selected', selected);
        offer.setAttribute('aria-pressed', String(selected));
      });

      this.querySelectorAll('[data-luma-card]').forEach((card) => {
        const order = selectedIds.get(card.dataset.productId);
        const selected = Boolean(order);
        card.classList.toggle('is-selected', selected);
        const button = card.querySelector('[data-luma-select]');
        const label = card.querySelector('[data-luma-select-label]');
        const badge = card.querySelector('[data-luma-order-badge]');
        button?.setAttribute('aria-pressed', String(selected));
        if (button) {
          const ariaLabel = selected
            ? button.dataset.removeAriaLabel
            : button.dataset.selectAriaLabel;
          if (ariaLabel) button.setAttribute('aria-label', ariaLabel);
        }
        if (label) {
          label.textContent = selected
            ? button?.dataset.selectedLabel || ''
            : button?.dataset.defaultLabel || '';
        }
        if (badge) badge.textContent = order ? String(order) : '';
      });

      const message = this.progressText();
      const countText = `${this.selected.length}/${this.offerQuantity}`;
      if (this.progressMessage) this.progressMessage.textContent = message;
      if (this.progressCount) this.progressCount.textContent = countText;
      if (this.summaryCount) this.summaryCount.textContent = countText;
      if (this.summaryMessage) {
        this.summaryMessage.textContent = this.incompleteText();
      }
      if (this.total) {
        const amount = document.createElement('bdi');
        amount.textContent = `${this.offerPrice} ${this.label('currencyLabel')}`;
        this.total.replaceChildren(amount);
      }

      if (this.progressSteps) {
        this.progressSteps.replaceChildren(
          ...Array.from({ length: this.offerQuantity }, (_, index) => {
            const step = document.createElement('span');
            step.classList.toggle('is-filled', index < this.selected.length);
            return step;
          }),
        );
      }

      if (this.thumbnails) {
        this.thumbnails.replaceChildren(
          ...Array.from({ length: this.offerQuantity }, (_, index) => {
            const product = this.selected[index];
            if (product?.imageUrl) {
              const image = new Image();
              image.src = product.imageUrl;
              image.alt = '';
              image.loading = 'lazy';
              image.width = 68;
              image.height = 84;
              image.dataset.productId = product.productId;
              image.classList.toggle(
                'is-awaiting-flight',
                this.pendingFlights.has(product.productId),
              );
              return image;
            }
            return document.createElement('span');
          }),
        );
      }

      const complete = this.selected.length === this.offerQuantity;
      if (this.cta) {
        this.cta.disabled = !complete;
        this.cta.textContent = complete
          ? this.label('labelCtaReady')
          : this.incompleteText();
      }
    }

    setupObserver() {
      this.observer?.disconnect();
      if (!this.sentinel || !this.nextUrl) {
        this.showEndState();
        return;
      }
      if (!('IntersectionObserver' in window)) {
        this.showLoadError('page');
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.loadNextPage();
          }
        },
        { rootMargin: '600px 0px', threshold: 0 },
      );
      this.observer.observe(this.sentinel);
    }

    setupFooterObserver() {
      this.footerObserver?.disconnect();
      const footer = document.querySelector('footer, [role="contentinfo"]');
      if (
        !this.summary ||
        !footer ||
        !('IntersectionObserver' in window)
      ) {
        return;
      }

      this.footerObserver = new IntersectionObserver(
        (entries) => {
          const footerVisible = entries.some((entry) => entry.isIntersecting);
          this.summary.classList.toggle('is-footer-visible', footerVisible);
          this.summary.toggleAttribute('inert', footerVisible);
          this.summary.setAttribute('aria-hidden', String(footerVisible));
        },
        { threshold: 0.01 },
      );
      this.footerObserver.observe(footer);
    }

    async loadNextPage() {
      if (
        this.isCatalogLoading ||
        this.isPageLoading ||
        !this.nextUrl
      ) {
        return;
      }
      const requestUrl = new URL(this.nextUrl, window.location.origin);
      const page = Number(requestUrl.searchParams.get('page') || 1);
      if (this.loadedPages.has(page)) {
        this.nextUrl = '';
        this.showEndState();
        return;
      }

      for (const parameter of ['preview_theme_id', 'view', '_fd', 'pb']) {
        const current = new URL(window.location.href).searchParams.get(parameter);
        if (current && !requestUrl.searchParams.has(parameter)) {
          requestUrl.searchParams.set(parameter, current);
        }
      }
      requestUrl.searchParams.set('section_id', this.sectionId);

      const controller = new AbortController();
      this.pageController = controller;
      this.isPageLoading = true;
      this.failedAction = 'page';
      this.setLoadState('loading');

      try {
        const response = await fetch(requestUrl.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: controller.signal,
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const parsedDocument = new DOMParser().parseFromString(
          await response.text(),
          'text/html',
        );
        if (controller.signal.aborted) return;
        const incomingRoot = this.findIncomingRoot(parsedDocument);
        const incomingGrid = incomingRoot?.querySelector(
          '[data-luma-page-items]',
        );
        if (!incomingGrid) throw new Error('Missing product page markup');

        const fragment = document.createDocumentFragment();
        let added = 0;
        incomingGrid.querySelectorAll('[data-luma-card]').forEach((card) => {
          const productId = card.dataset.productId;
          if (!productId || this.seenProductIds.has(productId)) return;
          this.seenProductIds.add(productId);
          fragment.append(card);
          added += 1;
        });
        this.grid?.append(fragment);
        this.loadedPages.add(page);

        const incomingSentinel = incomingRoot.querySelector(
          '[data-luma-sentinel]',
        );
        const incomingNextUrl = incomingSentinel?.dataset.nextUrl || '';
        if (added === 0 && incomingNextUrl) {
          throw new Error('The next page contained no new products');
        }
        this.nextUrl = incomingNextUrl;
        if (this.sentinel) {
          this.sentinel.dataset.nextUrl = this.nextUrl;
        }

        this.render();
        if (this.nextUrl) {
          this.setLoadState('idle');
        } else {
          this.showEndState();
        }
      } catch {
        if (controller.signal.aborted) return;
        this.showLoadError('page');
      } finally {
        if (this.pageController === controller) {
          this.pageController = null;
          this.isPageLoading = false;
        }
      }
    }

    setLoadState(state) {
      if (this.loader) this.loader.hidden = state !== 'loading';
      if (this.loadError) this.loadError.hidden = state !== 'error';
      if (this.loadEnd) this.loadEnd.hidden = state !== 'end';
    }

    showLoadError(action) {
      this.failedAction = action;
      this.setLoadState('error');
    }

    showEndState() {
      this.nextUrl = '';
      if (this.sentinel) {
        this.sentinel.dataset.nextUrl = '';
      }
      this.observer?.disconnect();
      this.setLoadState('end');
    }

    getPublicState() {
      const selectedProducts = this.selected.map((product) => ({ ...product }));
      return {
        offerQuantity: this.offerQuantity,
        totalPrice: this.offerPrice,
        selectedProducts,
        productIds: selectedProducts.map((product) => product.productId),
        variantIds: selectedProducts.map((product) => product.variantId),
        productTitles: selectedProducts.map((product) => product.title),
        imageUrls: selectedProducts.map((product) => product.imageUrl),
        sourcePageUrl: window.location.href,
      };
    }

    emitPackReady() {
      this.sanitizeSelected();
      this.persist();
      this.render();
      const eventName =
        this.dataset.packReadyEvent || DEFAULT_PACK_READY_EVENT;
      window.dispatchEvent(
        new CustomEvent(eventName, {
          detail: this.getPublicState(),
        }),
      );
    }
  }

  if (!customElements.get(ELEMENT_NAME)) {
    customElements.define(ELEMENT_NAME, LumaProductSelector);
  }
  window.setTimeout(function() {
    document.querySelectorAll(ELEMENT_NAME).forEach(function(element) {
      if (typeof element.ensureSelectionCartTrigger === 'function') element.ensureSelectionCartTrigger();
    });
  }, 100);
})();
